import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { ReturnAddressForm } from '../../utils/constant';
import { returnAddressInitialState as initialState } from './constants';
import { addReturnAddress, changeIsDefaultReturnAddress, editReturnAddress, getReturnAddresses } from './utils';

const returnAddressSlice = createSlice({
  name: 'returnAddress',
  initialState,
  reducers: {
    updateFormField(
      state,
      action: PayloadAction<{
        fieldName: keyof ReturnAddressForm;
        value: string;
      }>,
    ) {
      const { fieldName, value } = action.payload;

      state.formData[fieldName] = value;
    },
    handleReturnAddressSubmit(state) {
      state.formDataErrors = initialState.formDataErrors;
      state.requestSuccess = initialState.requestSuccess;
      state.requestError = initialState.requestError;

      const formData = state.formData;

      if (!formData.addressName && !formData.firmName) {
        state.formDataErrors = {
          ...state.formDataErrors,
          returnAddressNameError: 'Please Provide a Return Address Name or Firm Name',
        };
      }

      if (!formData.addressOne) {
        state.formDataErrors = {
          ...state.formDataErrors,
          address1Error: 'Address Line 1 is required',
        };
      }

      if (!formData.city) {
        state.formDataErrors = {
          ...state.formDataErrors,
          cityError: 'City is required',
        };
      }

      if (!formData.state) {
        state.formDataErrors = {
          ...state.formDataErrors,
          stateError: 'State is required',
        };
      }

      if (!formData.zipCode) {
        state.formDataErrors = {
          ...state.formDataErrors,
          zipError: 'Zip is required',
        };
      }
    },
    loadData(state, action) {
      state.formData = action.payload;
    },
    removeSuccessMsg(state) {
      state.requestSuccess = '';
    },
    clearErrors(state) {
      state.formDataErrors = {
        returnAddressNameError: '',
        firmNameError: '',
        address1Error: '',
        address2Error: '',
        cityError: '',
        stateError: '',
        zipError: '',
      };
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(editReturnAddress.fulfilled, (state, action) => {
        state.formData = action.payload;
        state.requestSuccess = 'Successfully updated address!';
      })
      .addCase(editReturnAddress.rejected, (state, action) => {
        state.requestError = action.payload ? (action.payload as string) : 'Something went wrong!';
      })
      .addCase(addReturnAddress.fulfilled, (state, action) => {
        state.formData = action.payload;
        state.requestSuccess = 'Successfully added address!';
      })
      .addCase(addReturnAddress.rejected, (state, action) => {
        state.requestError = action.payload ? (action.payload as string) : 'Something went wrong!';
      })
      .addCase(changeIsDefaultReturnAddress.pending, (state) => {
        state.isSettingDefaultAddress = true;
      })
      .addCase(changeIsDefaultReturnAddress.fulfilled, (state) => {
        state.isSettingDefaultAddress = false;
      })
      .addCase(changeIsDefaultReturnAddress.rejected, (state) => {
        state.isSettingDefaultAddress = false;
      })
      .addCase(getReturnAddresses.pending, (state) => {
        state.isFetchingAddresses = true;
      })
      .addCase(getReturnAddresses.fulfilled, (state) => {
        state.isFetchingAddresses = false;
      })
      .addCase(getReturnAddresses.rejected, (state) => {
        state.isFetchingAddresses = false;
      });
  },
});

export const { updateFormField, handleReturnAddressSubmit, loadData, removeSuccessMsg, clearErrors } =
  returnAddressSlice.actions;

export default returnAddressSlice.reducer;
